import { render, staticRenderFns } from "./UiPhoneInput.vue?vue&type=template&id=37b9102f&"
import script from "./UiPhoneInput.vue?vue&type=script&lang=js&"
export * from "./UiPhoneInput.vue?vue&type=script&lang=js&"
import style0 from "./UiPhoneInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports